import { Phone } from "lucide-react";
import { useEffect, useState } from "react";
import { CallLink } from "./CallLink";

export function Header() {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`sticky top-0 z-40 w-full transition-all ${
        scrolled ? "bg-background/90 backdrop-blur shadow-sm" : "bg-background"
      }`}
    >
      <div className="mx-auto flex max-w-6xl items-center justify-between px-4 py-3 sm:py-4">
        <a href="#" className="flex items-baseline gap-1.5 text-2xl font-black tracking-tight sm:text-3xl">
          <span className="text-foreground">TATA</span>
          <span className="text-accent">PLAY</span>
        </a>
        <CallLink
          location="header"
          label="Header Call Now"
          className="inline-flex items-center gap-2 rounded-full bg-accent px-4 py-2.5 text-sm font-semibold text-accent-foreground shadow-[var(--shadow-glow)] transition hover:brightness-110 sm:px-5 sm:text-base"
        >
          <Phone className="h-4 w-4" />
          <span className="hidden sm:inline">Call Now:</span> 6364894003
        </CallLink>
      </div>
    </header>
  );
}
